import { useState } from 'react';
import { DrilldownDialog } from './DrilldownDialog';
import { PartyBalanceDialog } from './PartyBalanceDialog';

// One place to open "show me the entries behind this number" dialogs.
export function useFinanceDrill() {
  const [drill, setDrill] = useState(null);
  const [party, setParty] = useState(null);
  const dialogs = (
    <>
      <DrilldownDialog request={drill} onClose={() => setDrill(null)} />
      <PartyBalanceDialog kind={party} onClose={() => setParty(null)} />
    </>
  );
  return { openDrill: setDrill, openParty: setParty, dialogs };
}
